export default {
  navTitle: "提醒本",
  home: "首页",
  create: "创建",
  airport: "微盘快传",
  recycle: "回收站",
  setting: "设置",
  download: "下载",
  feedback: "问题反馈",
  login: "登录",
  loginRegister: "登录&注册",
  langSwitch: "语言切换",
  back: "返回",
  save: "保存",
  Saving: "保存中...",
  clear: "清空",
  newcreate: "新建记录",
  uploadimg: "上传图片",
  uploadfille: "上传文件",
  Payment: "支付",
  // home
  searchPlaceholder: "搜索......",
  Untitled: '无标题',
  share: "分享",
  txt: "TXT文本",
  img: "图片",
  pdf: "PDF文档",
  delete: "删除",
  loading: "加载中...",
  // edit
  edit: "编辑记录",
  AddNewRecord: "新增记录",
  Pleaseenteratitle: "请输入标题（最多150个字符）",
  Pleaseentercontent: "请输入内容（最多200,000个字符）",
  Uploadimage : "上传图片（支持PNG、JPEG，单张图片最大20MB）",
  PasteImage: "右键或Ctrl+V在此粘贴图片...",
  Uploadfiles: "上传文件（支持Word、EXE、APK、压缩文件、mp4、msi、TXT，最多10个文件，单个文件最大50MB）",
  Theimage: "图片加载失败",
  ImagePreview: "图片预览",
  Checktheencryptednote: "加密笔记确认打√（否则内容保存不加密）",
  close: "关闭",
  file: '上传文件',
  ShareSettings: '分享设置',
  Setpassword: '设置密码（可选）',
  Enterthesharingpassword: '请输入分享密码',
  Validityperiod: '有效期:',
  oneDay: '1天',
  sevenDays: '7天',
  thirtyDays: '30天',
  Unlimited: '无限制',
  GenerateShareLink: '生成分享链接',
  Cancel: '取消',
  Sharelink: '分享链接:',
  CopyLink: '复制链接',
  Thefilecannotbeloaded: '文件加载失败:',
};